// Đồng hồ theo giờ máy chủ: đếm ngược giữ căn, "chờ n phút", đồng hồ chấm công không phụ thuộc giờ máy người dùng.
// Nguồn hiệu chỉnh: trường `serverTime` của phản hồi (chính xác, gọi trong queryFn), header `X-Server-Time`
// (khi gateway phát) hoặc dự phòng header `Date` (độ phân giải 1 giây ⇒ chỉ áp khi lệch > 2 s).
import { useEffect, useState } from 'react';

type When = string | number | Date | null | undefined;

/** Lệch giữa giờ máy chủ và giờ máy (ms): serverNow = Date.now() + offset. */
let offset = 0;
/** Ngưỡng áp dụng header Date (thô, làm tròn xuống giây). */
const DATE_HEADER_MIN_SKEW = 2_000;

const toMs = (t: When) => (t == null || t === '' ? NaN : typeof t === 'number' ? t : new Date(t).getTime());

/** Hiệu chỉnh chính xác theo thời điểm máy chủ trả về (ISO, epoch ms hoặc Date). Giá trị hỏng ⇒ bỏ qua. */
export function syncServerTime(t: When, localNow = Date.now()) {
  const ms = toMs(t);
  if (Number.isFinite(ms)) offset = ms - localNow;
}

/**
 * Hiệu chỉnh thô theo header HTTP `Date` ("Sat, 24 Oct 2026 21:22:30 GMT"): giờ thật nằm trong [Date, Date + 1 s)
 * ⇒ lấy giữa khoảng; chỉ áp khi chênh với độ lệch hiện có > 2 s (tránh làm hỏng hiệu chỉnh chính xác trước đó).
 */
export function syncServerDate(httpDate: string | null | undefined, localNow = Date.now()) {
  const ms = toMs(httpDate);
  if (!Number.isFinite(ms)) return;
  const skew = ms + 500 - localNow;
  if (Math.abs(skew - offset) > DATE_HEADER_MIN_SKEW) offset = skew;
}

/** Giờ máy chủ hiện tại (epoch ms). */
export const serverNow = () => Date.now() + offset;
/** Độ lệch đang áp (ms) — dùng cho kiểm thử / chẩn đoán. */
export const serverOffset = () => offset;
/** Chỉ dùng trong kiểm thử. */
export const resetServerClock = () => {
  offset = 0;
};

/** Giờ máy chủ cập nhật theo chu kỳ (mặc định mỗi giây). */
export function useServerNow(ms = 1000) {
  const [now, setNow] = useState(serverNow);
  useEffect(() => {
    setNow(serverNow());
    const t = setInterval(() => setNow(serverNow()), ms);
    return () => clearInterval(t);
  }, [ms]);
  return now;
}
